import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AreaCenter } from '../interfaces/area-center';


@Injectable({
  providedIn: 'root'
})
export class AreaCenterService {
  private myAppUrl: string;
  private myApiUrl: string;

  constructor(private http: HttpClient) {
    this.myAppUrl = environment.endpoint;
    this.myApiUrl = 'api/areacenters/'
  }
  getListAreaCenters(): Observable<AreaCenter[]> {
      return this.http.get<AreaCenter[]>(`${this.myAppUrl}${this.myApiUrl}`);
     }
   
     deleteAreaCenter(id: number): Observable<void> {
      console.log("id en service: "+id);
       return this.http.delete<void>(`${this.myAppUrl}${this.myApiUrl}${id}`)
     }
   
     saveAreaCenter(areacentro: AreaCenter): Observable<void> {
       return this.http.post<void>(`${this.myAppUrl}${this.myApiUrl}`,areacentro)
     }
   
     getAreaCenter(id: number): Observable<AreaCenter> {
       return this.http.get<AreaCenter>(`${this.myAppUrl}${this.myApiUrl}${id}`)
     }
   
     updateAreaCenter(id: number, areacentro: AreaCenter): Observable<void> {
       return this.http.put<void>(`${this.myAppUrl}${this.myApiUrl}${id}`, areacentro);
     }
   }